module.exports = __webpack_public_path__ + "img/setting_btn.d021656a.png";